/* eslint-disable @typescript-eslint/no-explicit-any */
export const isEqualByKeys = (obj1: any, obj2: any, keys: string[]) => {
  if (obj1 === obj2) {
    return true;
  }

  for (const key of keys) {
    if (!(key in obj1) || !(key in obj2) || obj1[key] !== obj2[key]) {
      return false;
    }
  }
  return true;
};
